import React from "react";
import CertificationsData from "../data/certifications";
import { FiArrowRight } from "react-icons/fi";

const Certifications = () => {
  return (
    <section id="certifications" className="py-20 bg-gray-50">
      <div className="container px-5 mx-auto">
        <div className="flex flex-col text-center w-full mb-12">
          <h1 className="sm:text-4xl text-3xl font-bold title-font mb-4 text-darkblue">
            Certifications
          </h1>
          <div className="h-1.5 w-20 bg-dark-orange rounded-full mx-auto"></div>
        </div>

        <div className="flex flex-wrap -m-4 justify-center">
          {CertificationsData.map((cert) => {
            const Icon = cert.icon;
            return (
              <div key={cert.id} className="p-4 md:w-1/2 lg:w-1/3 w-full" data-aos="fade-up">
                <div className={`h-full bg-white p-8 rounded-2xl border-2 transition-all duration-300 hover:shadow-xl ${cert.color}`}>
                  {/* Icon or Image rendering logic */}
                  <div className="mb-6 h-12 flex items-center">
                    {cert.image ? (
                      <img src={cert.image} alt={cert.issuer} className="h-8 w-auto object-contain" />
                    ) : (
                      <Icon className={`text-4xl ${cert.iconColor}`} />
                    )}
                  </div>

                  <h2 className="text-xl text-gray-900 font-bold mb-2">
                    {cert.title}
                  </h2>
                  <p className="text-gray-500 font-medium mb-6">
                    {cert.issuer} • {cert.date}
                  </p>

                  <a
                    href={cert.link}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center text-dark-orange font-bold hover:gap-3 transition-all cursor-pointer"
                  >
                    View Credential <FiArrowRight className="ml-2 text-lg" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;